import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  BookingItemStyle,
  UserSettings,
  showAsOptions,
  UnleashFeatureFlags,
} from '../interfaces/interfaces';
import { ToastService } from '../services/toast-service/toast.service';
import { Router } from '@angular/router';
import { UserStore } from '../stores/user.store';
import { NotificationPreferencesModalComponent } from '../modals/notification-preferences-modal/notification-preferences-modal.component';
import { LayoutPreferencesModalComponent } from '../modals/layout-preferences-modal/layout-preferences-modal.component';
import { BookingVisibilityPreferencesModalComponent } from '../modals/booking-visibility-preferences-modal/booking-visibility-preferences-modal.component';
import { Capacitor } from '@capacitor/core';
import { UnleashService } from '../services/unleash/unleash.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.page.html',
  styleUrls: ['./settings.page.scss'],
})

export class SettingsPage implements OnInit {
  showAsOptions = showAsOptions;
  readonly unleashFeatureFlags = UnleashFeatureFlags;
  userSettings: UserSettings = this.userStore.userPreferences().userSettings;
  showNotificationSettings: boolean = false;

  constructor(
    private toastService: ToastService,
    private router: Router,
    private userStore: UserStore,
    private modalController: ModalController,
    readonly unleashService: UnleashService,
  ) {}

  async ngOnInit() {
    this.showNotificationSettings = Capacitor.isNativePlatform()
      && this.unleashService.isEnabled(UnleashFeatureFlags.NOTIFICATION_ALLOW_PERMISSION);
    this.syncUserSettingsFromStore();
  }

  ionViewWillEnter(): void {
    this.syncUserSettingsFromStore();
  }

  private syncUserSettingsFromStore(): void {
    const prefs = this.userStore.userPreferences();
    if (prefs?.userSettings) {
      const s = prefs.userSettings;
      this.userSettings = {
        ...s,
        bookingItemStyle:
          s.bookingItemStyle === BookingItemStyle.Card ||
          s.bookingItemStyle === BookingItemStyle.Stack
            ? s.bookingItemStyle
            : BookingItemStyle.Card,
        showActiveBookings: s.showActiveBookings !== false,
        showExpiredBookings: s.showExpiredBookings !== false,
      };
    }
  }

  navigateToSupport() {
    this.router.navigate(['settings/information']);
  }

  changeStatus(event) {
    this.userStore.updateUserSettings({...this.userSettings, bookingStatus: event.target.value}).then(()=> {
      console.log('success')
    }).catch( () => {
      console.log('error')
      return this.settingsSomethingWentWrongToast()
    })
  }

  async settingsSomethingWentWrongToast() {
    await this.toastService.openErrorToastAsync('settingsSomethingWentWrongToast');
  }
  toggleAllowColleageFinding() {
    this.userStore.updateUserSettings({...this.userSettings, allowColleagueFinding: !this.userSettings.allowColleagueFinding}).then(()=> {
    }).catch( () => {
      return this.settingsSomethingWentWrongToast()
    })
  }

  async openNotificationPreferences(): Promise<void> {
    const modal = await this.modalController.create({
      component: NotificationPreferencesModalComponent,
      initialBreakpoint: 0.95,
      breakpoints: [0, 0.95],
      handle: false,
      canDismiss: async (data, role) => role != 'gesture',
    });

    await modal.present();
  }

  async openLayoutPreferences(): Promise<void> {
    if (!this.unleashService.isEnabled(UnleashFeatureFlags.BOOKING_CHANGE_DESIGN)) {
      return;
    }
    const modal = await this.modalController.create({
      component: LayoutPreferencesModalComponent,
      initialBreakpoint: 0.95,
      breakpoints: [0, 0.95],
      handle: false,
      canDismiss: async (data, role) => role != 'gesture',
    });

    await modal.present();
    await modal.onDidDismiss();
    this.syncUserSettingsFromStore();
  }

  async openBookingVisibility(): Promise<void> {
    const modal = await this.modalController.create({
      component: BookingVisibilityPreferencesModalComponent,
      initialBreakpoint: 0.95,
      breakpoints: [0, 0.95],
      handle: false,
      canDismiss: async (data, role) => role != 'gesture',
    });

    await modal.present();
    await modal.onDidDismiss();
    this.syncUserSettingsFromStore();
  }
}
